/** @jsxImportSource @emotion/react */
import Page from '@atlaskit/page';
import PageHeader from '@atlaskit/page-header';
import Skeleton from 'react-loading-skeleton';
import { css, jsx } from '@emotion/react';
import { FormattedMessage } from 'components/i18n';
import { PageWrapper } from '../../components/page';
import React from 'react';
import { useAuth } from '../auth';
import { angular2react } from 'angular2react';
import angular from 'angular';
import { lazyInjector } from '../../libs/lazyInjector'

const AngularDashboardComponent = {
  templateUrl: 'app/dashboard/dashboard.html',
  controller: 'DashboardCtrl',
  controllerAs: 'd'
};

angular.module('AccountingBoxApp')
  .component("dashboard", AngularDashboardComponent);
const Dashboard = angular2react('dashboard', AngularDashboardComponent, lazyInjector.$injector as angular.auto.IInjectorService);


const DashboardPage: React.FC = (props) => {
  const { currentUser } = useAuth();
  return (
    <PageWrapper>
    <Page>
      <PageHeader>
        <FormattedMessage
          id="dashboard.DashboardPage.title"
          defaultMessage="Dashboard"
        />
      </PageHeader>
      <div css={css`zoom: 0.8;
        .dashboard {
          background: white;
          padding: 0px;
        .page-header {
          display: none;
        }
      }
      `}>
        <Dashboard />
      </div>

      {/*<Skeleton count={4}/>*/}
    </Page>
    </PageWrapper>
  );
};

export default DashboardPage;
